<template>
  <div class="hint-button__wrapper">
    <div
      v-show="isHintButtonVisible"
      class="hint-icon__wrapper"
      :class="{'active': slideActive.isHintsVisible}"
      @click="toggleHintsSection()"
      @mouseenter="handleHoverOnButton('in')"
      @mouseleave="handleHoverOnButton('out')"
    >
      <aha-icon
        name="hint"
        width="25"
        height="25"
        viewBox="0 0 17 17"
        class="hint-icon __desktop"
        v-tooltip="{
          content: tooltipContent,
          offset: 0,
        }"
      />
      <aha-icon
        name="hint"
        width="25"
        height="25"
        viewBox="0 0 17 17"
        class="hint-icon __mobile"
        v-tooltip="tooltipContent"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import hintTooltipVideo from '@/assets/images/hints/hint-onboarding.webm'
import Utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import SlideApi from '@/api/slide'
import Socket from '@/socket'

export default {
  data() {
    return {
      hintTooltipVideo,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      currentUser: (state) => state.currentUser,
      presentation: (state) => state.presentation,
    }),
    isPickAnswerOrPickImage() {
      const { id, type, slideType } = this.slideActive
      return id && type === 'pickAnswer' && (!slideType || slideType === 'imageChoice')
    },
    isHintButtonVisible() {
      return this.isPickAnswerOrPickImage && !this.presentation.audiencePacing
    },
    tooltipContent() {
      return this.$i18nPresenter.t('Add hints to aid players')
    },
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    toggleHintsSection() {
      try {
        const payload = {
          isHintsVisible: !this.slideActive.isHintsVisible,
          socketId: Socket.getSocketId(), // for real-time collab
          uniqueAccessCode: this.presentation.uniqueAccessCode,
        }
        this.updateSlideActiveAction(payload)
        SlideApi.patchSlideById(this.slideActive.id, payload)
        Utils.mixpanelTracking(
          eventCategories.PRESENTATION_EDITOR,
          'Quiz hint > Show/hide button',
          'Quiz hint',
          '',
          {
            slideType: Utils.getCorrectSlideTypeName(this.slideActive.type,
              this.slideActive.slideType),
            slideId: this.slideActive.id,
            presentationId: this.presentation.id,
          },
        )
      } catch (error) {
        Sentry.captureException(error)
      }
    },
    handleHoverOnButton(mode) {
      if (mode === 'in') {
        Utils.mixpanelTracking(
          eventCategories.PRESENTATION_EDITOR,
          'Quiz hint > Hover',
          'Quiz hint',
          '',
          {
            slideType: Utils.getCorrectSlideTypeName(this.slideActive.type,
              this.slideActive.slideType),
            slideId: this.slideActive.id,
            presentationId: this.presentation.id,
          },
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.hint-button__wrapper {
  display: inline;
}

.hint-icon__wrapper {
  display: inline-block;
  cursor: pointer;
  padding: 3px 2px 1px 2px;
  border-radius: 5px;
  margin-left: 3px;
  @apply border border-transparent;
  &:hover {
    @apply bg-secondary-15;
    .hint-icon {
      color: #282E3E;
    }
  }
  &.active {
    @apply bg-secondary-15 border border-base-50;
  }
  .hint-icon {
    color: #525F7F;
    margin-top: -6px;
    &.__desktop {
      display: inline;
    }
    &.__mobile {
      display: none;
    }
  }
}
@media (max-width: 1180px) {
  .hint-button__wrapper {
    .hint-icon {
      &.__desktop {
        display: none;
      }
      &.__mobile {
        display: inline;
      }
    }
  }
}
</style>
